import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import { router } from "./router";
import store from "./store/store";

import {
  BIconCheckLg,
  BIconChevronDown,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronUp,
  BIconCloudArrowUpFill,
  BIconGearFill,
  BIconPenFill,
  BIconPlusLg,
  BIconSearch,
  BIconTrashFill,
  BIconX,
  BootstrapVue,
} from "bootstrap-vue";
// import VModal from "vue-js-modal";

import "@/assets/scss/bootstrap-overrides.scss";

Vue.use(BootstrapVue);
Vue.component("BIconCheckLg", BIconCheckLg);
Vue.component("BIconGearFill", BIconGearFill);
Vue.component("BIconChevronLeft", BIconChevronLeft);
Vue.component("BIconChevronRight", BIconChevronRight);
Vue.component("BIconChevronDown", BIconChevronDown);
Vue.component("BIconChevronUp", BIconChevronUp);
Vue.component("BIconCloudArrowUpFill", BIconCloudArrowUpFill);
Vue.component("BIconPenFill", BIconPenFill);
Vue.component("BIconPlusLg", BIconPlusLg);
Vue.component("BIconSearch", BIconSearch);
Vue.component("BIconTrashFill", BIconTrashFill);
Vue.component("BIconX", BIconX);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
